// Panel "Gợi ý" (FamilySuggestionsPanel) - ⭐ chỉ là preference nhẹ, không có bảng DB nào phía
// sau (đã chốt: list gợi ý là teaser tĩnh). Lưu ở localStorage, theo từng máy/trình duyệt.
const STORAGE_KEY = 'kristo_family_suggestion_stars'

export const getSuggestionStars = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        const parsed = raw ? JSON.parse(raw) : []
        return Array.isArray(parsed) ? parsed : []
    } catch (_) {
        return []
    }
}

export const toggleSuggestionStar = (key) => {
    const current = getSuggestionStars()
    const next = current.includes(key)
        ? current.filter((k) => k !== key)
        : [...current, key]
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    } catch (_) {
    }
    return next
}
